import type { ReactiveMap } from "@solid-primitives/map"
import { Vector3 } from "three"
import type { NeighborWaterCurrentCollection } from "../../../../rx/memo/useNodeNeighborBaseWaterCurrentReactiveMap"
import type { WaterFlowNode } from "../../../../rx/memo/useSharedWaterFlowNodeMapMemo"
import { VERTICES_PER_TILE } from "../../consts"
import setWorldPositionVector3WaterCurrentVector3 from "./setWorldPositionVector3WaterCurrentVector3"

const pCurrent = new Vector3()
const p0 = new Vector3()
const p1 = new Vector3()
const p2 = new Vector3()

const step1 = 64 / VERTICES_PER_TILE
const step2 = 32 / VERTICES_PER_TILE

export default function createWaterCurrentParticleLinePoints (
  nodeNeighborBaseWaterCurrentReactiveMap: ReactiveMap<number, NeighborWaterCurrentCollection>,
  waterFlowNodeMap: Map<number, WaterFlowNode>,
  gridWidth: number,
  origin1: Readonly<Vector3>,
  current2: Readonly<Vector3>,
): Array<Vector3> | undefined {
  let valid : boolean | void = true
  // current2 is the direction of the water current at the point (wx1, wy1)
  p0.copy(origin1)
  pCurrent.copy(current2)
  p1.copy(p0).addScaledVector(pCurrent, step1)
  valid = valid && setWorldPositionVector3WaterCurrentVector3(nodeNeighborBaseWaterCurrentReactiveMap, waterFlowNodeMap, gridWidth, p1, pCurrent)
  if (valid) {
    p2.copy(p1).addScaledVector(pCurrent, step2)
    valid = valid && setWorldPositionVector3WaterCurrentVector3(nodeNeighborBaseWaterCurrentReactiveMap, waterFlowNodeMap, gridWidth, p2, pCurrent)
  }

  if (valid) {
    return [p0.clone(), p1.clone(), p2.clone()]
  }
  // return immutableEmptyArray as unknown as Array<Vector3>
}